import { player_x, player_y } from "./constants";

const log_parent = document.getElementById("event-log") as HTMLInputElement
const lost = document.getElementById("lost") as HTMLSpanElement

let letter = 65;

export class _Target{
    x: number
    z: number
    timer: number
    name: string

    
    x_v: number
    z_v: number

    constructor(x: number, z:number){
        this.x = x;
        this.z = z;
        this.name = String.fromCharCode(letter);
        letter += 1;
        if( letter >= 65+26){
            letter = 65;
        }

        const x_d = player_x - x;
        const z_d = player_y - z;
        const d = Math.sqrt(x_d ** 2 + z_d ** 2) * 0.2;
        this.timer = d;
        this.x_v = x_d/d;
        this.z_v = z_d/d;
    }

    step(delta: number){
        this.x += this.x_v * delta;
        this.z += this.z_v * delta;
        this.timer -= delta;
        if(this.timer < 0){
            console.log("LOST!! booo!")
            lost.style.display = "block";
        }
    }

    draw(ctx:CanvasRenderingContext2D){
        ctx.fillStyle="red";
        ctx.beginPath()
        ctx.arc(this.x, this.z, 5, 0, Math.PI*2);
        ctx.fill()
        ctx.fillStyle="black";
    }

    remove(){
    }
}

export class RadioEvent{
    element:HTMLParagraphElement|null
    time:number
    constructor(msg: string, parent:HTMLElement|null=null){
        const elem = document.createElement("p")
        elem.style.color = "grey";
        elem.innerHTML = msg;
        const p = parent || log_parent;
        p.prepend(elem);
        this.element = elem;
        this.time = 0;
    }

    step(delta:number){
        this.time += delta;

        // if (this.time > 30){
        //     this.element.style.color
        // }
        // if(this.time > 30 && this.element){
        //     this.element.remove()
        //     this.element = null;
        // }
    }
}

export const events:RadioEvent[] = []

export function addEvent(text:string, parent:HTMLElement|null=null){
    const event = new RadioEvent(text, parent)
    events.push(event);
    // setTimeout(() => {
    //     events.splice(events.indexOf(event), 1)
    // }, 30);
}

